/**
 *  All api related to system setting
 */

import _ from 'lodash'
import axios from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

// - fetch disabled checkouts
export function fetchDisableCheckouts(options = {}) {
  const { page = 1, ...others } = options
  const params = {
    includes: ['delivery_type', 'commerce_channel'].join(','),
    page,
    ...others
  }
  const source = axios.CancelToken.source()
  cancelRequest.add(
    'fetchDisableCheckouts',
    () => source.cancel('fetchDisableCheckouts: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'disable_checkouts',
      method: 'get',
      params,
      cancelToken: source.token,
      arrayFormat: 'brackets'

    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      disableCheckouts: data.disableCheckouts,
      pagination: data.disableCheckoutsPagination,
      next: _.get(data, 'disableCheckoutsPagination.nextPage') > page
        ? () =>
          fetchDisableCheckouts({
            page: page + 1,
            ...others
          })
        : null,
      all: page === 1 && _.get(data, 'disableCheckoutsPagination.nextPage') > 1
        ? () => Promise.all(
          _.times(
            _.get(data, 'disableCheckoutsPagination.totalPages') - 1,
            (index) => fetchDisableCheckouts({
              pageCountless: true,
              page: index + 2,
              ...others
            }),
          ),
        )
        : null,
      count: _.get(data, 'disableCheckoutsPagination.totalCount')
    }))
}
